import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['signer', 'myName', 'display'];

  connect() {
    this.signerTarget.addEventListener('input', this.boundUpdateName);
    this.updateName();
  }

  disconnect() {
    this.signerTarget.removeEventListener('input', this.boundUpdateName);
  }

  updateName() {
    this.toggleButton();
    if (this.signerTarget.value.length > 0) {
      this.myNameTarget.textContent = this.signerTarget.value;
    } else {
      this.myNameTarget.textContent = 'Sign with your Name';
    }
  }

  toggleButton() {
    if (this.signerTarget.value.trim().length === 0) {
      this.displayTarget.classList.add('d-none');
    } else {
      this.displayTarget.classList.remove('d-none');
    }
  }
}
